import * as type from '../actions/types';

const initialState = {
  data: [],
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_PAYMENT_METHODS_PENDING: {
      return {
        ...state,
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.FETCH_PAYMENT_METHODS_SUCCESS: {
      return {
        ...state,
        data: action.payload.data.map(JSON.parse),
        pending: false,
        success: true,
      };
    }

    case type.FETCH_PAYMENT_METHODS_FAILURE: {
      return {
        ...state,
        error: action.payload,
        pending: false,
      };
    }

    default: {
      return state;
    }
  }
};
